<template>
  <v-container>
    <vue-snotify></vue-snotify>
    <v-card>
      <v-card-title class="cyan darken-1">
        <span class="white--text">Crear plan</span>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <br />
          <v-row>
            <v-col cols="12" md="3"></v-col>
            <v-col cols="12" md="6">
              <v-select v-model="select" :rules="serviceRules" :items="services" item-text="name" item-value="id"
                prepend-icon="mdi-view-list" label="Seleccionar servicio *" persistent-hint return-object></v-select>
              <v-select v-model="select_billing" :rules="billingRules" :items="billings" item-text="text"
                item-value="value" prepend-icon="mdi-table-clock" label="Seleccionar período *"></v-select>
              <v-text-field v-model="name" :rules="nameRules" :counter="190" prepend-icon="mdi-octagram" label="Nombre">
              </v-text-field>
              <v-text-field v-model="price" type="number" :rules="priceRules" :counter="10" prefix="$"
                prepend-icon="mdi-cash-multiple" label="Precio *" required></v-text-field>
              <v-text-field v-model="priceUF" :rules="priceUfRules" :counter="10" prefix="$"
                prepend-icon="mdi-cash-multiple" label="Precio UF" required></v-text-field>
              <v-textarea v-model="description" :rules="descriptionRules" :counter="500"
                prepend-icon="mdi-format-list-group" label="Descripción *"></v-textarea>
            </v-col>
            <v-col cols="12" md="3"></v-col>
          </v-row>
          <br /><br />
          <v-divider></v-divider> <br />
          <v-row>
            <v-col cols="12" lg="4"></v-col>
            <v-col cols="12" lg="8">
              <div class="text-right pr-15">
                <v-btn color="primary" class="mr-4" outlined @click="cancel" width="125">
                  <v-icon>mdi-close-circle</v-icon> Cancelar
                </v-btn>
                <v-btn color="primary" @click="create" outlined width="125">
                  <v-icon>mdi-check-circle</v-icon> Crear
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import axios from "axios";
import VueSnotify from "vue-snotify";
import SnotifyMixin from "@/mixins/DisplayNotificationMixin.vue";

export default {
  mixins: [SnotifyMixin],
  VueSnotify,

  data: () => ({
    services: [],
    name: "",
    description: "",
    price: "",
    priceUF: "",
    select: "",
    select_billing: "",
    billing: "",
    billings: [
      { text: "Mensual", value: "mensual" },
      { text: "Semestral", value: "semestral" },
      { text: "Anual", value: "anual" },
      { text: "Bienal", value: "bienal" },
      { text: "Trienal", value: "trienal" },
    ],
   descriptionRules: [
      (v) =>
        (v.length <= 500) || "El campo no debe exceder de 500 caracteres",
    ],
    nameRules: [
      v => !!v || 'El nombre es requerido',
      v => v && v.length <= 25 || 'El nombre de plan no debe exceder los 25 caracteres',
    ],

    serviceRules: [
      v => !!v || 'El servicio es requerido'
    ],
    billingRules: [
      v => !!v || 'El período es requerido'
    ],

    priceRules: [
      v => !!v || 'El precio es requerido',
      v => v >= 0 || 'El valor precio debe ser mayor o igual a cero',
    ],
    priceUfRules: [
      v => !!v || 'El precio uf es requerido',
      v => v >= 0 || 'El valor precio debe ser mayor o igual a cero',
    ],
  }),

  mounted() {
    this.getServices();
  },
  methods: {
    cancel() {
      setTimeout(() => this.$router.push({ name: "plans" }), 10);
    },

    create() {
      console.log("entra");
      let request = {
        name: this.name,
        description: this.description,
        price: this.price,
        id_service: this.select.id,
        price_uf: this.priceUF,
        billing: this.select_billing,
      };

      console.log(request);
      if (this.select != "") {
        axios
          .post("/save-plan", request)
          .then((response) => {
            this.displayNotification("success", "Éxito", "Plan creado correctamente");
            console.log(response.data);
            setTimeout(() => this.$router.push({ name: "plans" }), 4000);
          })
          .catch((err) => {
            console.log(err, "error");
            this.displayNotification("error", "Error", "No se pudo guardar el plan");
            setTimeout(() => this.$router.push({ name: "plans" }), 4000);
          });
      } else {
        this.displayNotification(
          "error",
          "Error",
          "Debe seleccionar un servicio"
        );
      }
    },

    async getServices() {
      axios
        .get("/services")
        .then((response) => {
          console.log(response.data);
          this.services = response.data;
        })
        .catch((err) => {
          console.log(err, "error");
          this.displayNotification("error", "Error", "Error al obtener servicios");
        });
    },
  },
};
</script>